import { render, staticRenderFns } from "./EyeChart.vue?vue&type=template&id=032b3070&scoped=true"
import script from "./EyeChart.vue?vue&type=script&lang=js"
export * from "./EyeChart.vue?vue&type=script&lang=js"
import style0 from "./EyeChart.vue?vue&type=style&index=0&id=032b3070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b3070",
  null
  
)

export default component.exports